import { Button, type ButtonProps } from '@kc-console/common-ui';
import { EXTERNAL_LINK, isGov } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';
import { IcChatRegular, IcMailRegular } from '@kep/kcds-icons';

interface InqueryButtonProps extends ButtonProps {
  isInService?: boolean;
}

export default function InqueryButton({ isInService = false, ...props }: InqueryButtonProps) {
  const { t } = useTranslation();

  const handleOpenGovMail = () => {
    const url = isGov()
      ? `mailto:${EXTERNAL_LINK.GOV_HELPDESK_MAIL}`
      : EXTERNAL_LINK.CONTACT_SUPPORT;

    window.open(url, '_blank', 'noopener noreferrer');
  };

  if (isInService) {
    return (
      <Button variant="primary" size="lg" onClick={handleOpenGovMail} {...props}>
        {t('ui:error_page.contact_inquiry')}
      </Button>
    );
  }

  return (
    <Button
      variant="tertiary"
      size="xl"
      startIcon={isGov() ? <IcChatRegular /> : <IcMailRegular />}
      onClick={handleOpenGovMail}
      {...props}
    >
      {t('ui:error_page.contact_inquiry')}
    </Button>
  );
}
